/* ===========================================================================
   US SAVAGE - valla para custom.js de la plantilla.
   custom.js va tal cual, pero dos de sus bloques buscan por toda la pagina
   (`select:not(.ignore)` y los slider de slick) y en Shopify eso alcanzaria a
   los selectores del tema y del carrito. Aqui se limitan a lo que este dentro
   de .fr; fuera de ahi no hacen nada.
   =========================================================================== */
(function ($) {
  if (!$ || !$.fn) return;
  function limitar(nombre) {
    var original = $.fn[nombre];
    if (typeof original !== 'function') return;
    $.fn[nombre] = function () {
      var dentro = this.filter(function () {
        return this.closest && this.closest('.fr');
      });
      if (!dentro.length) return this;
      return original.apply(dentro, arguments);
    };
  }
  limitar('niceSelect');
  limitar('slick');
})(window.jQuery);
